// Nadpisy sekcí stránky výsledků hledání z API (searchApiModel.js).
export default {
  cats: 'Kategorie',
  brands: 'Značky',
  posts: 'Články',
  pages: 'Stránky',
};
